import { parseISO } from 'date-fns';

// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/Date
const INVALID_DATE = new Date(8640000000000001);
type FormatDate = (date: Date | string | number | null) => Date;

export const formatDate: FormatDate = (date = INVALID_DATE) => {
  if (date === null || date === undefined) {
    return INVALID_DATE;
  }
  return typeof date === 'string'
    ? parseISO(date)
    : new Date(date);
};
